export default __webpack_public_path__ + "media/metronic/_theme/media/logos/logo-4-sm-7182981ff79f022878d1888d0490b077.png";